<div class="selector-container">
  <span class="selector-container--title">{{ 'VerticalSelectorComponent.loginTitle' | translate }}</span>
  <span class="text-md semi-bold">{{ 'VerticalSelectorComponent.select' | translate }}</span>
  <div class="row gap-lg flex-wrap center text-align-center">
    <ng-container *ngFor="let customer of customerList.items">
      <div class="selector-container--dashboard-button">
        <a (click)="setVerticalAndGoLogin(customer)" class="button-link" mat-raised-button>
          <div class="column center gap-md">
            <img class="button-link-icon" [src]="customer.logoUrlBase + 'sidebar-logo.svg'"/>
            <span class="text-md grey-color-700">{{ customer.name }}</span>
          </div>
        </a>
      </div>
    </ng-container>
  </div>
</div>
